const API_HOST = process.env.REACT_APP_API_HOST;

const API_URL = `${API_HOST}/amhsb/api/v1`;

export async function fetchCategories() {
  const res = await fetch(`${API_URL}/categories`);
  return res.json();
}

export async function fetchArchivedCategories() {
  const res = await fetch(`${API_URL}/categories?archived=true`);
  return res.json();
}

export async function fetchItems(categoryId) {
  const res = await fetch(`${API_URL}/items?categoryId=${categoryId}`);
  return res.json();
}

export async function fetchArchivedItems(categoryId) {
  const res = await fetch(`${API_URL}/items?categoryId=${categoryId}&archived=true`);
  return res.json();
}

export async function fetchNewItems() {
  const res = await fetch(`${API_URL}/items/new`);
  return res.json();
}

export async function fetchSpecialOfferItems() {
  const res = await fetch(`${API_URL}/items/special-offer`);
  return res.json();
}

export async function fetchMuseumItems() {
  const res = await fetch(`${API_URL}/museum-items`);
  return res.json();
}

export async function fetchItem(itemId) {
  const res = await fetch(`${API_URL}/items/${itemId}`);
  return res.json();
}


export async function fetchMuseumItem(museumItemId) {
  const res = await fetch(`${API_URL}/museum-items/${museumItemId}`);
  return res.json();
}